import { atom } from 'recoil'
import { keyFactory } from 'src/utils/recoil'

const settingKey = keyFactory('contact-us')

export const open = atom<boolean>({
  key: settingKey('open'),
  default: false,
})
